module.exports = __webpack_public_path__ + "static/media/icon-4-01.e4fa799d.png";